import React from 'react';
import Utils from '../../lib/Utils';
import API from '../../lib/API';

class KaoLaboForm extends React.Component {

  state = {
    
    school: this.props.data.school || this.props.data.albums[0].code,
    limit_date: '',
    memo: '',
  }


  componentDidMount = () => {
    this.loadAlbumData(this.state.school);
    this.validation();
  }

  getData = () => {

    let formData = {
      doc_date: (new Date()).toLocaleDateString('sv-SE'),
      limit_date: this.state.limit_date,
      customer: this.props.data.customerName,
      hinmei: this.props.data.albums.find(a=>a.code===this.state.school).hinmei,
      code:  this.state.school.replace(/(\d{2})$/, '-$1'),
      group_id: 'G'+this.state.school.substring(0,7),
      account_1_name:'',
      account_1_id:'',
      account_1_password:'',
      account_2_name:'',
      account_2_id:'',
      account_2_password:'',
      account_3_name:'',
      account_3_id:'',
      account_3_password:'',
      memo: this.state.memo,
    };
    return {
      schoolCode: this.state.school,
      hinmei: this.props.data.albums.find(a=>a.code===this.state.school).hinmei,
      filename: "かおラボ申請_" + Utils.getHyphenationDate(),
      form: formData
    };
  }

  validation = () => {
    let newState = {};

    this.setState(newState);
    this.props.changeValidate(Object.values(newState).every(v=>v===null));
  }

  handleChangeValue = e => {
    let newState = {};
    newState[e.target.name] = e.target.value.trim();
    this.setState(newState, () =>{
      this.validation();
    });

    if (e.target.name === 'school') {
      this.loadAlbumData(e.target.value);
    }
  }

  loadAlbumData = (schoolCode) => {
    this.props.doLoading('アルバムデータの読み込み中');
    API.getAlbum(schoolCode).then(data=>{
      this.setState({
        limit_date: data.info.expectedDate.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3'),
      });
      this.props.doLoading(null);
    });
  }

  handleMouseDownDatePicker = e => {
    let name = e.target.name;
    this.props.openDatePicker(e.target, value => {
      let newState = {};
      newState[name] = value;
      this.setState(newState, () =>{
        this.validation();
      });
    })
  }

  renderForm = () => {
    return (<form ref={ref=>{this.form=ref}}>

      <div className="formBlock titleBlock">
        <div className="titleBlock-wrap">
          <h2>かおラボ 学校アカウントの申し込み</h2>
          <div>顔認証写真セレクトシステムの申し込みフォームです。</div>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">対象の学校</div>
        <div className="formBlock-input">
          <select name="school" value={this.state.school} onChange={this.handleChangeValue}>{
            this.props.data.albums.map(a => {
              return <option key={a.code} value={a.code}>{a.hinmei}</option>
            })
          }</select>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">備考</div>
        <div className="formBlock-input">
          <textarea name="memo" value={this.state.memo} onChange={this.handleChangeValue}></textarea>
        </div>
      </div>



    </form>)
  }

  renderConfirm = () => {
    return (
      <div>
        <div className="formBlock titleBlock">
          <div className="titleBlock-wrap">
            <h2>かおラボ 学校アカウントの申し込み</h2>
            <div>内容をよくご確認の上、ご申請ください。</div>
          </div>
        </div>
        <div className="confirm">
          <div className="confirm-row">
            <label>学校</label>
            <span>{this.props.data.albums.find(a=>a.code===this.state.school).hinmei}</span>
          </div>
          <div className="confirm-row">
            <label>アカウント有効期限</label>
            <span>{this.state.limit_date}</span>
          </div>
          <div className="confirm-row">
            <label>備考</label>
            <span>{this.state.memo}</span>
          </div>
          
        </div>
      </div>
    )
  }

  render () {
    switch (this.props.progress) {
      case 'form': return this.renderForm();
      case 'confirm': return this.renderConfirm();
      default: return null;
    }
  }
}
export default KaoLaboForm;